<template>
  <div>
    <div class="annual-highlight">
      <h2 class="annual_title">2023 {{ $t("corporate.match_highlight") }}</h2>
      <div class="coming_soon_box">
        <!-- <div class="coming_soon_content">
          <h1 class="coming_soon">{{ $t("home.nodata") }}</h1>
        </div> -->
        <div class="main_image_container line">
        <div v-for="(image, index) in year_2023" :key="index">
          <img :src="image.temp_path_url" @click="handleImageClick(image.id)" />
          <h3>{{ processCaption(image) }}</h3>
        </div>
      </div>
      </div>
      <hr />
    </div>
    <div class="annual-highlight">
      <h2 class="annual_title">2022 {{ $t("corporate.match_highlight") }}</h2>
      <div class="main_image_container line">
        <div v-for="(image, index) in year_2022" :key="index">
          <img :src="image.temp_path_url" @click="handleImageClick(image.id)" />
          <h3>{{ processCaption(image) }}</h3>
        </div>
      </div>
      <hr />
    </div>
    <div class="annual-highlight">
      <h2 class="annual_title">2021 {{ $t("corporate.match_highlight") }}</h2>
      <div class="main_image_container">
        <div>
          <img :src="year_2021[0].temp_path_url" alt="" 
          @click="handleImageClick(year_2021[0].id)" />
          <h3>{{ $t("corporate.highlight2021") }}</h3> 
        </div>
        <div>
          <div class="img-box">
            <img
              :src="year_2021[1].temp_path_url"
              alt=""
              @click="handleImageClick(year_2021[1].id)"
            />
          </div>
          <h3>{{ $t("corporate.champion2021") }}</h3> 
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { BasketballApi } from "../../../api/basketball";
export default {
  data() {
    return {
      year_2022: ["","",""],
      year_2021: [],
      year_2023: [],
      lang: ""
    };
  },
  methods: {
    handleImageClick(id) {
      this.$router.push({
        path: `/highlights-album-corporate/${id}`,
        query: { type: this.headType }
      });
    },
    getImageCorporateHighlight() {
      BasketballApi.getHighlightCorporate()
        .then(res => {
          res.forEach(album => {
            if (album.year === "2021") {
              this.year_2021.push(album);
            } else if (album.year === "2022") {
              if (album.name_en == "2022 Finals Highlight"){
                this.year_2022[1] = album;
              } else if (album.name_en == "2022 Group Stage Highlight"){
                this.year_2022[2] = album;
                const tempPhotoList = Array.from(Array(album.photos.length).keys());
              } else {
                this.year_2022[0] = album;
              }
            } else if(album.year === "2023") {
              this.year_2023.push(album)
            }
          });
        })
        .catch(err => console.log(err.message));
        console.log("year_2023", this.year_2023)
    },
    processCaption(image) {
      return this.lang === "en" ? image.name_en : image.name_zh_hk;
    }
  },
  created() {
    this.getImageCorporateHighlight();
    console.log(this.year_2022)
    this.lang = localStorage.getItem("locale");
  },
  computed: {
    ...mapState(["headType"])
  }
};
</script>

<style lang="scss" scoped>
.annual-highlight {
  h2 {
    color: #318bc8;
    text-align: center;
    font-size: 28px;
    // margin-left: 4rem;
    margin-top: 2rem;
    margin-bottom: 1rem;
  }

  h1 {
    color: #4f9ccf;
    opacity: 0.8;
    font-size: 44px;
    margin-top: 2rem;
    margin-bottom: 2.5rem;
  }

  .coming_soon_content {
    margin-top: 140px;
    margin-bottom: 140px;
  }

  .coming_soon {
    text-align: center;
    vertical-align: middle;
  }

  hr {
    border-top: 3px solid #bbb;
  }

  .main_image_container {
    padding: 20px;
    display: grid;
    grid-template-columns: repeat(3, 32%);
    gap: 20px;

    img {
      width: 100%;
      height: 300px;
      border-radius: 5px;
      cursor: pointer;
    }
  }
}

@media screen and (max-width: 1080px) {
  .annual-highlight {
    .main_image_container {
      grid-template-columns: repeat(2, 50%);

      img {
        width: 400px;
        margin-left: auto;
        margin-right: auto;
      }
    }
  }
}

@media screen and (max-width: 880px) {
  .annual-highlight {
    .main_image_container {
      grid-template-columns: repeat(1, 100%);
    }
  }
}
</style>
